import React from 'react';
import { color, radius, shadow, space } from '../theme';
import BackLink from './BackLink';

interface DetailHeaderProps {
  // Where "back" goes when the page was opened directly (see BackLink)
  fallback: string;
  fallbackLabel: string;
  // Icon buttons on the band, at the far end (use IconButton with onDark)
  actions?: React.ReactNode;
  // A photo or logo centred on the card's top edge (MK and party pages)
  avatar?: React.ReactNode;
  // Card contents: badges, the entity's name, meta lines
  children: React.ReactNode;
  bandColor?: string;
}

/* Top of a detail page in the app-native look: a colored band holding the back link
   and actions, with a white card overlapping it that names the entity. */
const DetailHeader = ({ fallback, fallbackLabel, actions, avatar, children, bandColor = color.primaryInk }: DetailHeaderProps) => (
  <header>
    <div style={{
      background: bandColor,
      minHeight: avatar ? 132 : 108,
      padding: `${space.xs}px ${space.md}px 0`,
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: space.sm,
    }}>
      <div style={{ minWidth: 0 }}><BackLink fallback={fallback} fallbackLabel={fallbackLabel} onDark /></div>
      {actions && <div style={{ display: 'flex', gap: space.sm, paddingTop: space.xs }}>{actions}</div>}
    </div>
    <div style={{
      position: 'relative',
      margin: `${avatar ? -60 : -52}px ${space.lg}px 0`,
      background: color.surface,
      borderRadius: radius.xl + 4,
      boxShadow: shadow.card,
      padding: avatar ? `0 ${space.lg}px ${space.lg}px` : space.lg,
      textAlign: avatar ? 'center' : undefined,
    }}>
      {avatar && <div style={{ display: 'flex', justifyContent: 'center', marginTop: -44, marginBottom: space.sm }}>{avatar}</div>}
      {children}
    </div>
  </header>
);

export default DetailHeader;
